import React, { useCallback, useEffect, useRef, useState } from "react";

const CustomDraggableModal = ({
  isOpen,
  onClose,
  children,
  resetPositionDependencyArray = [],
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isMobile, setIsMobile] = useState(false);
  const startPos = useRef({ x: 0, y: 0 });
  const popupRef = useRef(null);
  const originalBodyOverflow = useRef(null);

  // Detektuj da li je mobilni uređaj
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const onMouseMove = useCallback(
    (e) => {
      if (!isDragging || isMobile) return;
      setPosition({
        x: e.clientX - startPos.current.x,
        y: e.clientY - startPos.current.y,
      });
    },
    [isDragging, isMobile]
  );

  const onMouseUp = () => {
    setIsDragging(false);
  };

  const onMouseDown = (e) => {
    if (isMobile) return; // Onemogući dragging na mobilnom
    e.stopPropagation();
    setIsDragging(true);
    startPos.current = { x: e.clientX - position.x, y: e.clientY - position.y };
  };

  useEffect(() => {
    if (!isMobile) {
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
      return () => {
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
      };
    }
  }, [onMouseMove, isMobile]);

  useEffect(() => {
    if (!isOpen) {
      setPosition({ x: 0, y: 0 });
    }
  }, [isOpen]);

  useEffect(() => {
    setPosition({ x: 0, y: 0 });
  }, resetPositionDependencyArray);

  // Prevent body scroll when modal is open on mobile
  useEffect(() => {
    if (isOpen && isMobile) {
      if (originalBodyOverflow.current === null) {
        originalBodyOverflow.current = document.body.style.overflow;
      }
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = originalBodyOverflow.current ?? '';
    }
    
    return () => {
      document.body.style.overflow = originalBodyOverflow.current ?? '';
    };
  }, [isOpen, isMobile]);

  if (!isOpen) return null;

  return (
    <div 
      className={`custom-draggable-modal-overlay ${isMobile ? 'mobile' : ''}`}
    >
      <div
        className={`custom-draggable-modal padding-lg ${isMobile ? 'mobile' : ''}`}
        ref={popupRef}
        onClick={(e) => e.stopPropagation()}
        style={!isMobile ? { transform: `translate(${position.x}px, ${position.y}px)` } : {}}
        onMouseDown={onMouseDown}
      >
        <div className="custom-draggable-modal-content">{children}</div>
      </div>
    </div>
  );
};

export default CustomDraggableModal;